KXL.module('Components.BootstrapCarousel', function (Carousel, KXL, Backbone, Marionette, $, _) {
	"use strict";

	KXL.reqres.setHandlers({
		'get:carousel': function (tags) {
			return Carousel.Controller.getCarousel(tags);
		}
	});

});